import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconSliceVideoFill = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--slice-video-fill")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_3894_206" style={{ maskType: "alpha", }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
  <rect width="24" height="24" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_3894_206)">
  <path d="M7.17279 15.3077H13.7882V15.1423C13.7882 14.6141 13.476 14.1763 12.8516 13.8288C12.2273 13.4814 11.4369 13.3077 10.4805 13.3077C9.52408 13.3077 8.73369 13.4814 8.10932 13.8288C7.48497 14.1763 7.17279 14.6141 7.17279 15.1423V15.3077ZM10.4805 11.6923C10.9023 11.6923 11.2577 11.5478 11.5468 11.2587C11.8359 10.9696 11.9805 10.6141 11.9805 10.1923C11.9805 9.77052 11.8359 9.41507 11.5468 9.12595C11.2577 8.83685 10.9023 8.6923 10.4805 8.6923C10.0587 8.6923 9.70324 8.83685 9.41414 9.12595C9.12504 9.41507 8.98049 9.77052 8.98049 10.1923C8.98049 10.6141 9.12504 10.9696 9.41414 11.2587C9.70324 11.5478 10.0587 11.6923 10.4805 11.6923ZM5.09587 19C4.6356 19 4.2513 18.8458 3.94297 18.5375C3.63464 18.2292 3.48047 17.8449 3.48047 17.3846V6.61537C3.48047 6.15512 3.63464 5.77083 3.94297 5.4625C4.2513 5.15417 4.6356 5 5.09587 5H15.8651C16.3254 5 16.7097 5.15417 17.018 5.4625C17.3263 5.77083 17.4805 6.15512 17.4805 6.61537V11.2692L20.519 8.23075V15.7692L17.4805 12.7308V17.3846C17.4805 17.8449 17.3263 18.2292 17.018 18.5375C16.7097 18.8458 16.3254 19 15.8651 19H5.09587Z" fill="#403CAB"/>
  </g>
  </IconWrapper>
)
